module.exports = __webpack_public_path__ + "static/media/icomoon.6f29627f.woff";